import React from "react";
import ReactDOM from "react-dom";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "./index.scss";
import RedSocialApp from "./RedSocialApp";

ReactDOM.render(<RedSocialApp />, document.getElementById("root"));
